/**
 * Shared integration display metadata (2026-08-19).
 *
 * One friendly-name map for every surface that names an app in copy —
 * onboarding rows/coach (lowercase funnel voice), the connect-app chat tool
 * (Title Case), and anything else that would otherwise grow its own map.
 * Icons, categories, and descriptions stay live from the Composio catalog
 * (`tk.meta.logo` / `tk.name`) — this module only covers the hand-written
 * names used in sentences, where the catalog's casing is not the voice we
 * want.
 */

export const INTEGRATION_FRIENDLY_NAMES: Record<string, string> = {
  gmail: 'Gmail',
  googlecalendar: 'Google Calendar',
  googledrive: 'Google Drive',
  googlesheets: 'Google Sheets',
  googledocs: 'Google Docs',
  googleslides: 'Google Slides',
  slack: 'Slack',
  github: 'GitHub',
  notion: 'Notion',
  linear: 'Linear',
  outlook: 'Outlook',
  hubspot: 'HubSpot',
  salesforce: 'Salesforce',
  jira: 'Jira',
  asana: 'Asana',
  dropbox: 'Dropbox',
  box: 'Box',
  one_drive: 'OneDrive',
  onedrive: 'OneDrive',
  microsoft_teams: 'Microsoft Teams',
  calendly: 'Calendly',
  zoom: 'Zoom',
  stripe: 'Stripe',
  quickbooks: 'QuickBooks',
  trello: 'Trello',
  mailchimp: 'Mailchimp',
  typeform: 'Typeform',
  youtube: 'YouTube',
  docusign: 'DocuSign',
  dropbox_sign: 'Dropbox Sign',
  pandadoc: 'PandaDoc',
  xero: 'Xero',
  freshbooks: 'FreshBooks',
  monday: 'Monday.com',
  clickup: 'ClickUp',
  todoist: 'Todoist',
  basecamp: 'Basecamp',
  airtable: 'Airtable',
  zendesk: 'Zendesk',
  intercom: 'Intercom',
  whatsapp: 'WhatsApp',
  linkedin: 'LinkedIn',
  gitlab: 'GitLab',
  miro: 'Miro',
  figma: 'Figma',
  canva: 'Canva',
};

/** Title Case name for chat/task copy ("Connecting Google Drive…"). */
export function friendlyIntegrationName(slug: string): string {
  return INTEGRATION_FRIENDLY_NAMES[slug.toLowerCase()] || slug;
}

/** Lowercase name for the onboarding funnel voice ("google drive"). */
export function prettyIntegrationName(slug: string): string {
  const friendly = INTEGRATION_FRIENDLY_NAMES[slug.toLowerCase()];
  return friendly ? friendly.toLowerCase() : slug.replace(/_/g, ' ');
}
